/* eslint-disable import/order */
import { csmCustomerContextTenantMigratedStatusResource } from '@jira/router-resources__service-desk-customer-service-customers-organizations-common/src/csmCustomerContextTenantMigratedStatusResource.tsx';
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { AsyncDirectoryNav } from '@jira/navigation-apps__horizontal-nav-jsm-directory/src/index.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { servicedeskCustomersV2Route } from '@jira/router-routes__servicedesk-customers-routes/src/servicedeskCustomersV2Route.tsx';

import {
	getServiceDeskNavigationResources,
	getServicedeskPageContextResources,
} from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { ServiceDeskContacts } from './ui/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const servicedeskCustomersV2RouteEntry: Route = createEntry(
	servicedeskCustomersV2Route,
	() => ({
		group: 'servicedesk',
		layout: serviceProjectLayout,

		resources: [
			...getServiceDeskNavigationResources(),
			...getServicedeskPageContextResources(),
			getConsolidationStateResource(),
			csmCustomerContextTenantMigratedStatusResource,
		],

		// eslint-disable-next-line no-restricted-syntax
		component: ServiceDeskContacts,
		forPaint: [LazyAtlassianNavigation],
		perfMetricKey: 'jsm-customers-component-load',
		ufoName: 'jsm-customers-component-load',

		navigation: {
			menuId: MenuIdProjects,
			horizontal: AsyncDirectoryNav,
			// TODO: Remove this during jira_nav4 cleanup
		},

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
